/* 
PROTECTED PAGE 
*/
import React from "react";
import Dashboard from "../../Components/Dashboard/Dashboard";
import Layout from "../../Components/Layout/Layout";

function DashboardPage() {
  return (
    <Layout>
      <Dashboard />
    </Layout>
  );
}

export default DashboardPage;
